export function deepClone<T>(obj: T): T {
  if (typeof structuredClone === 'function') return structuredClone(obj);
  return obj == null ? (obj as any) : JSON.parse(JSON.stringify(obj));
}
